import { Spinner } from '@/components/common/Spinner';
import { Box } from '@mui/material';

export default function PanelLoadingPlaceholder() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        width: '100%',
      }}
    >
      <Spinner type='circular' />
    </Box>
  );
}
